import { logEvent } from "./analytics";
import { menuMusicBtnEl } from "./elements";
import store from "./store";
import { translate } from "./internationalization";
import { initSound, loopMp3, stopMp3 } from "./sound";
import { resetLangAttributeOfLeafs } from "./translate";

export function switchMusicCb(e) {
  e.stopImmediatePropagation();
  store.set("disableMusic", !store.disableMusic);
  setMusic();
  logEvent("set_music");
}

export function setMusic() {
  menuMusicBtnEl.innerHTML = translate(
    "🎶 Music: " + (store.disableMusic ? "Disabled" : "Enabled")
  );
  resetLangAttributeOfLeafs(menuMusicBtnEl);
  if (store.disableMusic) stopMp3("background");
  else loopMp3("background");
}

initSound();
